import * as THREE from "three";
import Apartment from "../model/Apartment";
import Product from "../model/Product";
import { findBoundingBoxByProductType } from "../utils/geometryUtils"
import { ElementTypeEnum } from "../elementTypeMappings";

export default class ApartmentViewModel {
    apartment: Apartment;
    spaces: Product[];

    constructor(apartment: Apartment, spaces: Product[]) {
        this.apartment = apartment;
        this.spaces = spaces;
    }

    getBoundingBox(scene: THREE.Scene) {
        return findBoundingBoxByProductType(scene, this.spaces, [ElementTypeEnum.Space]);
    }
}